{
  "#WWS_ABC_ANALYSIS": {
    "TITLE": "ABC-Analyse",
    "CONFIGURATION": {
      "PLACEHOLDER": "Analyse-Variante"
    },
    "FILTER": {
      "RESET": "Zurücksetzen",
      "PERIOD": "Zeitraum",
      "SALES_ORGANISATION": "Verkaufsorganisation",
      "MAIN_GROUP": "Hauptgruppe",
      "SUB_GROUP": "Untergruppe",
      "SUPPLIER": "Lieferant",
      "PRODUCT_GROUP": "Produktgruppe",
      "PRODUCT": "Artikel",
      "DEPARTMENT": "Abteilung",
      "COST_CENTER": "Kostenstelle",
      "PROMOTION": "Aktion",
      "SLOW_MOVER_ONLY": "Nur Ladenhüter",
      "IN_STOCK_ONLY": "Nur mit Lagerstand",
      "IN_ACTIVE_PROMOTION_ONLY": "Nur Aktionsartikel"
    },
    "DETAIL_HINT": "Zeile wählen für Artikeldetails",
    "SORT_HINT": "Spaltenkopf klicken zum Sortieren",
    "SEARCH_PLACEHOLDER": "Artikel-Nr. oder Bezeichnung ...",
    "ARTICLE_COUNT_LABEL": "Art.",
    "OVERVIEW_LOAD_ERROR": "Ein Fehler ist aufgetreten - bitte ändern Sie die Filter!",
    "SEGMENT_TOOLTIP": {
      "ARTICLE_LABEL": "Artikel"
    },
    "SEGMENT_TITLE": "Segment",
    "CLASSIFIED_BY": "Klassifizierung nach",
    "SCOPE_LABEL": "Umfang",
    "EDIT_FILTERS_BUTTON": "Filter bearbeiten",
    "FILTERS_ACTIVE_LABEL": "Filter aktiv",
    "PAGE_LABEL": "Seite",
    "COLUMNS": {
      "SEGMENT": "Segment",
      "PRODUCT_NUMBER": "Artikel",
      "PRODUCT_DESCRIPTION": "Bezeichnung",
      "RANK": "Rang",
      "SHARE_PERCENT": "Anteil %",
      "CUMULATIVE_PERCENT": "Kum. %",
      "ARTICLE_COUNT": "Anzahl",
      "ARTICLE_COUNT_PERCENT": "Anzahl %",
      "SALES_QUANTITY": "VK-Menge",
      "CONTRIBUTION_MARGIN": "DB",
      "CONTRIBUTION_MARGIN_PERCENT": "DB %",
      "NET": "Umsatz",
      "NET_PERCENT": "Umsatz %",
      "INVENTORY_QUANTITY": "Lagermenge",
      "INVENTORY_VALUE": "Lagerwert",
      "INVENTORY_VALUE_PERCENT": "Lagerwert %"
    },
    "DETAIL_PANEL": {
      "VKORG_COLUMN": "Vkorg",
      "TOTAL_LABEL": "Gesamt",
      "LISTED_BADGE": "Gelistet",
      "NOT_LISTED_BADGE": "Nicht Gelistet",
      "SALES_ORGANISATIONS_TITLE": "Verkaufsorganisationen",
      "SALES_ORGANISATIONS_HINT": "Zeile wählen – Kennzahlen unten gelten je Verkaufsorganisation.",
      "SALES_SECTION_TITLE": "Verkauf im Zeitraum",
      "STOCK_SECTION_TITLE": "Lager",
      "PURCHASE_SECTION_TITLE": "Einkauf",
      "SALES_PRICE": "Verkaufspreis",
      "LAST_SALES_DATE": "Letzter Verkauf",
      "PURCHASE_QUANTITY": "Menge Einkauf",
      "LAST_PURCHASE_PRICE": "Letzter EK-Preis",
      "FIRST_PURCHASE_DATE": "Erster Einkauf",
      "LAST_PURCHASE_DATE": "Letzter Einkauf",
      "DAYS_NOT_SOLD": "Tage ohne Verkauf",
      "CUMULATIVE": "kumuliert",
      "PRODUCT_NR": "Art.-Nr."
    }
  }
}
